<script>
export default {
    name: "mineButton",
    props: [ "loading", "disabled" ],
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        btnTap(){
            this.$emit('click');
        }
    },
};
</script>

<template>
    <div class="btn" :class="{gray: disabled}" @click.stop="btnTap">
        <div class="loading" v-if="loading"></div>
        <slot v-else></slot>
    </div>
</template>

<style scoped lang="scss">
.btn{
    .loading{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &::after{
            content: "";
            display: block;
            width: 20px;
            height: 20px;
            border: 2px solid #fff;
            border-top-color: transparent;
            border-radius: 100%;
            animation: circle infinite 0.75s linear;
        }
    }
    // 转转转动画
    @keyframes circle {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    @media screen and (max-width: 768px) {
        .loading{
            &::after{
                width: .3rem;
                height: .3rem;
            }
        }
    }
}
</style>